export default {
    get (key) {
        try {
            let translations = {}
            // Header
            translations['CANNOT_CHANGE_WAREHOUSE'] = 'Je kunt het magazijn niet veranderen omdat je producten in je winkelwagen hebt liggen! Als je op OK klikt wordt de winkelwagen leeg gemaakt!'
            // Register page
            translations['registrationSuccess'] = 'Je registratie is bijna voltooid. Je ontvangt een automatische e-mail om je account te bevestigen.'
            translations['RegistrationUnauthorizedEmailAddress'] = 'Dit e-mailadres is al in gebruik of is niet bevoegd om te registeren.' // 'Het e-mailadres is al in gebruik.'
            translations['InvallidModelState'] = 'Eén van de verplichte velden is niet correct ingevuld.'
            translations['No ConfirmPassword given'] = 'Het herhaal wachtwoord komt niet overeen met het wachtwoord.'
            translations['The passwords dont match.'] = 'De opgegeven wachtwoorden komen niet overeen.'
            translations['The entered e-mail address is unauthorized.'] = translations['RegistrationUnauthorizedEmailAddress']
            translations['The password does not meet the minimum requirements for a strong password.'] = 'Het wachtwoord voldoet niet aan de minimale eisen voor een sterk wachtwoord.'
            translations['MissingCompanyName'] = 'De naam van de organisatie ontbreekt.'
            translations['This e-mailaddress is already in use by another user.'] = translations['RegistrationUnauthorizedEmailAddress']
            // Login page
            translations['Succes_RegistrationConfirm'] = 'Je account is succesvol bevestigd, je kunt nu inloggen.'
            translations['Exception_RegistrationConfirmWrongInput'] = ''
            translations['InlogSucces'] = 'Je bent ingelogd.'
            translations['IncorrectDetails'] = 'Je wachtwoord of gebruikersnaam is incorrect.'
            translations['UserNotApproved'] = 'Je account is not niet bevestigd.'
            translations['UserDoesNotExist'] = 'Sorry, je e-mailadres werd niet herkend door ons systeem. Je maakt best een nieuw gebruikersprofiel aan.'
            translations['ResetPassword'] = 'Vul hieronder je e-mailadres in. Je ontvangt een e-mail waarmee je je wachtwoord kunt wijzigen.'
            translations['No Basic authetication found.'] = translations['IncorrectDetails']
            translations['TooManyUsers'] = 'Het maximum aantal ingelogde BorrowMe gebruikers dat je licentie toelaat is bereikt.'

            // ResetPassword
            translations['PASSWORD_MISMATCH'] = 'Wachtwoord komt niet overeen!'
            translations['WEAK_PASSWORD'] = 'Wachtwoord voldoet niet aan de eisen!'
            translations['PASSWORD_RESET_FAILURE'] = 'Er is iets mis gegaan met het veranderen van je wachtwoord!'
            translations['PASSWORD_RESET_SUCCESS'] = 'Je wachtwoord is met succes veranderd!'
            translations['SOMETHING_WENT_WRONG'] = 'Er is iets mis gegaan!'

            // SingleItem
            translations['ITEM_PUT_IN_CART'] = 'Het product is in de winkelwagen geplaatst.'
            translations['CONTINUE_SHOPPING'] = 'Verder winkelen'
            translations['TO_CART'] = 'Naar winkelwagen'

            // UserDetails
            translations['SUCESSFULLY_EDITED_USER_DETAILS'] = 'Je gegevens zijn met succes bijgewerkt!'

            // Status
            translations['Active'] = 'Actief'
            translations['Order'] = 'Geaccepteerd'

            translations['UnknownError'] = 'Oops. Er ging iets mis.'

            return translations[key]
        } catch (error) {
            return 'Oops. Er ging iets mis.'
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/TranslationService.js